import React, { useEffect, useContext } from 'react'
import { AuthContext } from '@/layout/Auth'
import { TextField, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Message } from '@cx/ui'
import Modal2 from '@/components/Modal2'
import { createOrg } from '@/api'
import { Controller, useForm } from 'react-hook-form'

interface DissolutionSpaceModalProps {
  open: boolean
  onCancel: () => void
  onOk: (org: any) => void
}

const CreateNewSpaceModal: React.FC<DissolutionSpaceModalProps> = ({ open, onCancel, onOk }) => {
  const navigate = useNavigate()
  const { authInfo } = useContext(AuthContext)
  const orgInfo = authInfo?.orgInfo
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      name: '',
    },
  })

  const onSubmit = handleSubmit((data) => {
    createOrg(data).then((res) => {
      onCancel()
      onOk(res)
    })
  })

  useEffect(() => {
    if (!open) {
      reset()
    }
  }, [open])

  return (
    <Modal2 title='创建新空间' width={625} open={open} onCancel={onCancel} onOk={onSubmit}>
      <Stack gap={3}>
        <Controller
          rules={{
            required: '请输入空间名称',
          }}
          name='name'
          control={control}
          render={({ field }) => (
            <TextField
              required
              label='空间名称'
              placeholder='请输入'
              {...field}
              variant='outlined'
              fullWidth
              error={Boolean(errors.name)}
              helperText={errors.name?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
      </Stack>
    </Modal2>
  )
}

export default CreateNewSpaceModal
